import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import Button from "components/CustomButtons/Button.js";
import Tooltip from "@mui/material/Tooltip";
import Add from "@mui/icons-material/Add";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import styles from "../ServicesSections.module.scss";
export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center" alignItems="flex-start" spacing={8}>
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our Approach</h3>

          <p>
            We see search engine marketing as a great relationship, from the very
            first chat to a happily ever after. Here's how it works:
            <br />
          </p>
          <ol>
            <li>
              <strong>Fill in the form at the bottom of this page</strong>:
              During the call, we get to know each other, to understand your
              goals and for you to understand how we can help you.{" "}
              <i>(We get to know each other on our first date!)</i>
            </li>
            <li>
              {" "}
              <strong>We get down to creating a marketing plan for you</strong>:
              The plan will be specifically tailored to your business needs and
              goals
              <i>
                (This is where the magic happens! Sparks fly, butterflies in
                stomach, think of the possibilities!)
              </i>
            </li>
            <li>
              {" "}
              <strong>We execute your marketing plan:</strong> This is where you
              watch your revenue grow.{" "}
              <i>
                (Like any good date, we hit the ground running and it’s like
                nothing you’ve ever experienced before)
              </i>
            </li>
            <li>
              {" "}
              <strong>Grow, Win, Celebrate! </strong>{" "}
              <i>(Wedding! Okay maybe that’s too soon…)</i>
            </li>
          </ol>
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
